import { Link } from 'react-router-dom';

import ContentPage from '../components/ui/ContentPage';

const FAQ: { q: string; a: React.ReactNode }[] = [
  {
    q: 'Que é exactamente LeyroChain?',
    a: (
      <>
        Unha plataforma de trazabilidade dixital de gando bovino que rexistra cada evento relevante
        (vacinas, traslados, peso, propietarios, produción) e ancorase diariamente en blockchain
        pública (Polygon) para que sexa imposible alteralo a posteriori.
      </>
    ),
  },
  {
    q: 'Substitúe a SITRAN ou os rexistros oficiais?',
    a: (
      <>
        Non. LeyroChain é un <strong>rexistro paralelo enriquecido</strong>. Os actos veterinarios
        oficiais seguen indo a SITRAN co certificado dixital colexial. Nós engadimos histórico
        verificable, comprobación rápida en campo (NFC) e QR público para compradores e
        consumidores.
      </>
    ),
  },
  {
    q: 'Como compro un animal?',
    a: (
      <>
        Explora o <Link to="/marketplace">catálogo</Link>, abre o animal que che interese, fai clic
        en <em>Reservar</em> e completa o pagamento e a sinatura do contrato dixital. O cargo
        retense en escrow ata que confirmas a recepción do animal.
      </>
    ),
  },
  {
    q: 'Como vendo un animal (venda directa ou subasta)?',
    a: (
      <>
        Como gandeiro/a, abres a app móbil, seleccionas o animal e premes <em>Pór á venda</em>.
        Configuras venda directa (prezo fixo) ou subasta. Vexa{' '}
        <Link to="/marketplace/vender">os pasos completos aquí</Link>.
      </>
    ),
  },
  {
    q: 'Que datos garda LeyroChain de min?',
    a: (
      <>
        Os imprescindibles para operar a plataforma. Detalle completo en{' '}
        <Link to="/marketplace/privacidade">Política de privacidade</Link>.
      </>
    ),
  },
];

export default function HelpPage(): JSX.Element {
  return (
    <ContentPage
      title="Centro de axuda"
      intro="Respostas ás preguntas máis frecuentes. Se non atopas a túa, escríbenos a info@leyro.es."
    >
      <div className="space-y-6 not-prose">
        {FAQ.map((item, idx) => (
          <details
            key={idx}
            className="border border-border rounded-2xl p-5 bg-white open:shadow-card transition-shadow"
          >
            <summary className="cursor-pointer font-semibold text-dark text-base list-none flex items-center justify-between">
              {item.q}
              <span className="text-rauxa text-xl ml-3">+</span>
            </summary>
            <p className="text-sm text-dark leading-relaxed mt-3">{item.a}</p>
          </details>
        ))}
      </div>
    </ContentPage>
  );
}
